import {
  useEffect,
  useRef,
  useState,
} from 'react'
import {
  CreditCard,
  Loader2,
} from 'lucide-react'
import {
  useSearchParams,
} from 'react-router-dom'
import {
  billingService,
  getApiErrorMessage,
} from '../services/api'

export function BillingPortalRedirectPage(): JSX.Element {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const started = useRef(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    // React StrictMode runs effects twice in development. Mint exactly one
    // Stripe session per page load even there.
    if (started.current) return
    started.current = true

    if (!token) {
      setError('This billing link is incomplete. Ask Catch for a new one.')
      return
    }

    billingService.createPortalSessionFromLink(token)
      .then(({ url }) => window.location.replace(url))
      .catch((err) => {
        setError(getApiErrorMessage(
          err,
          "We couldn't open your billing portal. Ask Catch for a new link.",
        ))
      })
  }, [token])

  return (
    <main className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <section className="w-full max-w-md bg-white border border-gray-200 rounded-2xl p-8 text-center shadow-sm">
        <CreditCard className="w-12 h-12 text-primary-500 mx-auto mb-5" />
        {error ? (
          <>
            <h1 className="text-2xl font-semibold text-gray-900 mb-3">
              Billing link unavailable
            </h1>
            <p className="text-gray-600">{error}</p>
          </>
        ) : (
          <>
            <Loader2 className="w-6 h-6 text-primary-500 animate-spin mx-auto mb-4" />
            <h1 className="text-2xl font-semibold text-gray-900 mb-3">
              Opening your billing portal
            </h1>
            <p className="text-gray-600">
              Creating a fresh, secure Stripe session…
            </p>
          </>
        )}
      </section>
    </main>
  )
}
